<template>
  <BiddersTeamsProject :projectId="projectId" />
  <PartnersTeamsProject :projectId="projectId" />
</template>

<script>
import BiddersTeamsProject from '@/components/projects/bidders/teams/BiddersTeamsProject.vue'
import PartnersTeamsProject from '@/components/projects/partners/teams/PartnersTeamsProject.vue'

export default {
  name: 'TeamsProject',

  components: {
    BiddersTeamsProject,
    PartnersTeamsProject,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
}
</script>
